// Some parameters are sent via URL hash to prevent sensitive information from being logged in server logs.
// This utility function extracts specific parameters from the URL hash.
export const getHashParam = (param: string, path: string): string | null => {
  const hash = path.split('#')[1]
  if (!hash) return null
  const params = new URLSearchParams(hash)
  return params.get(param)
}
